import fetch from 'utils/fetch'

export function CreateReagent (data) {
  return fetch({
    url: `/project/reagent/createReagent`,
    // url: `${process.env.REA_API}/project/reagent/createReagent`,
    method: 'post',
    data
  })
}
export function getReagentDetail (data) {
  return fetch({
    url: `/project/reagent/getReagentDetail`,
    // url: `${process.env.REA_API}/project/reagent/getReagentDetail`,
    method: 'post',
    data
  })
}
export function getMetaCvReagentAddInfoValueList (data) {
  return fetch({
    url: `/project/reagent/getMetaCvReagentAddInfoValueList`,
    // url: `${process.env.REA_API}/project/reagent/getMetaCvReagentAddInfoValueList`,
    method: 'post',
    data
  })
}

export function getMetaCvReagentTypeList (data) {
  return fetch({
    url: `/project/reagent/getMetaCvReagentTypeList`,
    // url: `${process.env.REA_API}/project/reagent/getMetaCvReagentTypeList`,
    method: 'post',
    data
  })
}

export function getReagentList (data) {
  return fetch({
    url: `/project/reagent/getFuzzyReagentList`,
    // url: `${process.env.REA_API}/project/reagent/getFuzzyReagentList`,
    method: 'post',
    data
  })
}

export function getReagentManufacturerList (data) {
  return fetch({
    url: `/project/reagent/getReagentManufacturerList`,
    // url: `${process.env.REA_API}/project/reagent/getReagentManufacturerList`,
    method: 'post',
    data
  })
}
export function getReagentApplicationList (data) {
  return fetch({
    url: `/project/reagent/getReagentApplicationList`,
    // url: `${process.env.REA_API}/project/reagent/getReagentApplicationList`,
    method: 'post',
    data
  })
}
// modify
export function modifyReagent (data) {
  return fetch({
    url: `/project/reagent/modifyReagent`,
    // url: `${process.env.REA_API}/project/reagent/modifyReagent`,
    method: 'post',
    data
  })
}

export function getReagentListSize (data) {
  return fetch({
    url: `/project/reagent/getFuzzyReagentListSize`,
    // url: `${process.env.REA_API}/project/reagent/getFuzzyReagentListSize`,
    method: 'post',
    data
  })
}
export function createReagentInPrepration (data) {
  return fetch({
    url: `/project/reagent/createReagentInPrepration`,
    // url: `${process.env.REA_API}/project/reagent/createReagentInPrepration`,
    method: 'post',
    data
  })
}
export function getMetaCvReagentConjugate (data) {
  return fetch({
    url: `/project/reagent/getMetaCvReagentConjugate`,
    // url: `${process.env.REA_API}/project/reagent/getMetaCvReagentConjugate`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/reagent.js